module.exports = __webpack_public_path__ + "static/img/videosift.com.bc393ba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/thumbs/videosift.com.jpg
// module id = 40
// module chunks = 1